/* eslint-disable */
export const BathCollectionData = [
  {
    collectionId: 'Family-311464272',
    anchorId: '206942731',
    kitchenAnchorId: '',
    shopInspiration: [{
      imageUrl: 'https://images.thdstatic.com/productImages/c7a0f274-9b4a-4bac-8e5c-923fe290bb1c/svn/vibrant-polished-brass-kohler-shower-bathtub-trim-kits-k-t398-4-pb-40_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.5945374145507812',
            yCoordinate: '0.9147623291015625'
          },
          omsIDs: [
            '318320175',
            '311893628',
            '318320199',
            '203181342',
            '203181385'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.4903145751953125',
            yCoordinate: '0.1665719757080078'
          },
          omsIDs: [
            '315294155'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.697055908203125',
            yCoordinate: '0.778638427734375'
          },
          omsIDs: [
            '100456278',
            '203099865',
            '307908572',
            '203094641',
            '203006194'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.07698800659179687',
            yCoordinate: '0.9362589111328125'
          },
          omsIDs: [
            '328668843',
            '325732194',
            '328331970',
            '328331976',
            '325732193'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.2523309020996094',
            yCoordinate: '0.7406823120117187'
          },
          omsIDs: [
            '205505224',
            '100675266',
            '100626499',
            '303316094',
            '100024261'
          ]
        }
      ]
    },
    {
      imageUrl: 'https://images.thdstatic.com/productImages/51b5213d-6cb7-4a78-9e9f-77ef0bbbefae/svn/polished-chrome-american-standard-towel-hooks-7018210-002-4f_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.08493463134765625',
            yCoordinate: '0.8982025756835937'
          },
          omsIDs: [
            '332425943',
            '331260317',
            '331260322',
            '326632650',
            '322209318'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.7619420776367187',
            yCoordinate: '0.20896612548828125'
          },
          omsIDs: [
            '316451294',
            '309638066',
            '316342297',
            '327673940',
            '309514923'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.4111205749511719',
            yCoordinate: '0.7144605102539062'
          },
          omsIDs: [
            '205445122',
            '205445126',
            '324649617',
            '303398146',
            '330316133'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.2085147247314453',
            yCoordinate: '0.647756103515625'
          },
          omsIDs: [
            '313759087',
            '323580820',
            '331425035',
            '320696085',
            '207182418'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.9515115966796875',
            yCoordinate: '0.38681500244140626'
          },
          omsIDs: [
            '302350152',
            '100649970',
            '331297667',
            '205591730',
            '303569830'
          ],
        },
        {
          coordinate: {
            xCoordinate: '0.7686182250976562',
            yCoordinate: '0.25142430114746095'
          },
          omsIDs: [
            '331565616',
            '331565148',
            '323814156',
            '325834590',
            '315280249'
          ]
        }
      ]
    }],
    shopByRoom: [{
      url: '/collection/bathroom/modern_escape/id-40596',
      metadata: {
        name: 'Modern Escape',
        style: [
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/0a1ee577-9ef4-4462-bf2e-f9429bf3352c19.jpeg'
      }
    },
    {
      url: '/collection/bathroom/retro_revival/id-40598',
      metadata: {
        name: 'Retro Revival',
        style: [
          'Classic',
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/0208e90b-2aa9-468f-80ee-f0dad1dd616220.jpeg'
      }
    },
    {
      url: '/collection/bathroom/coastal_classics_bathroom/id-39984',
      metadata: {
          name: 'Coastal Classics Bathroom',
          style: [
              'Modern'
          ],
          room: [
              'Bathroom'
          ],
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/2a17faa7-d794-40cb-8893-f6d5a1ec2ab32.jpeg'
      }
    }]
  },
  {
    collectionId: 'Family-311464234',
    anchorId: '301980333',
    kitchenAnchorId: '204314922',
    shopInspiration: [
      {
        imageUrl: 'https://images.thdstatic.com/productImages/cc9ed1e1-62cf-44f6-a408-4a3826ada3dc/svn/matte-black-magazine-racks-h-thg04mb-64_1000.jpg',
        hotspots: [
          {
            coordinate: {
              xCoordinate: '0.24840214538574218',
              yCoordinate: '0.7653592529296875'
            },
            omsIDs: [
              '323454534',
              '323443908',
              '207030780',
              '324229747',
              '322971359'
            ]
          },
          {
            coordinate: {
              xCoordinate: '0.4986605224609375',
              yCoordinate: '0.24717861938476562'
            },
            omsIDs: [
              '306181634',
              '323483714',
              '323067277',
              '322855889',
              '323236377'
            ]
          },
          {
            coordinate: {
              xCoordinate: '0.756024658203125',
              yCoordinate: '0.7228634643554688'
            },
            omsIDs: [
              '331224792',
              '302478944',
              '306778655',
              '327790106',
              '328558836'
            ]
          }
        ]
      },
      {
        imageUrl: 'https://images.thdstatic.com/productImages/f32430df-814b-47c6-9248-e0962ec7737a/svn/matte-black-gatco-towel-bars-4241mx-1f_1000.jpg',
        hotspots: [
          {
            coordinate: {
              xCoordinate: '0.8058906860351562',
              yCoordinate: '0.15999134826660155'
            },
            omsIDs: [
              '304524877',
              '328746364',
              '306216180',
              '313647133',
              '328682846'
            ]
          },
          {
            coordinate: {
              xCoordinate: '0.3851468505859375',
              yCoordinate: '0.14646681213378906'
            },
            omsIDs: [
              '328746376',
              '314126897',
              '329882871',
              '328746364',
              '331622115'
            ]
          },
          {
            coordinate: {
              xCoordinate: '0.6051553955078125',
              yCoordinate: '0.3719049987792969'
            },
            omsIDs: [
              '202245044',
              '316258959',
              '316258908',
              '323260474',
              '202245142'
            ]
          },
          {
            coordinate: {
              xCoordinate: '0.6561819458007813',
              yCoordinate: '0.7307371215820313'
            },
            omsIDs: [
              '317612203',
              '327606060',
              '315596821',
              '324414213',
              '324278777'
            ]
          }
        ]
      }
    ],
    shopByRoom: [{
      url: '/collection/bathroom/timeless_touches/id-40594',
      metadata: {
        name: 'Timeless Touches',
        style: [
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/ece20e2f-762a-4fd4-9bed-b871a6ecfe8018.jpeg'
      }
    },
    {
      url: '/collection/bathroom/modern_escape/id-40424',
      metadata: {
        name: 'Modern Escape',
        style: [
          'Classic',
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/0208e90b-2aa9-468f-80ee-f0dad1dd616220.jpeg'
      }
    },{
      url: '/collection/bathroom/modern_geometric_bathroom/id-39290',
      metadata: {
          name: 'Geometric Bathroom',
          style: [
              'Modern'
          ],
          room: [
              'Bathroom'
          ],
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/2eb631f9-2da1-4dd8-80d5-b87fb80ea92a4.jpeg'
      }
    }]
  },
  {
    collectionId: 'Family-307891248',
    anchorId: '100000989',
    kitchenAnchorId: '',
    shopInspiration: [{
      imageUrl: 'https://images.thdstatic.com/productImages/71f189fb-50d8-421f-8407-d050f4cf1ae1/svn/oil-rubbed-bronze-kohler-towel-hooks-k-10555-2bz-66_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.1628955078125',
            yCoordinate: '0.1890731201171875'
          },
          omsIDs: [
            '332056331',
            '318218503',
            '328146309',
            '330508905',
            '318886056'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.39930596923828127',
            yCoordinate: '0.24821560668945314'
          },
          omsIDs: [
            '203782993',
            '301066080',
            '301066076',
            '100421394',
            '100652726'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.2066812286376953',
            yCoordinate: '0.6750020141601563'
          },
          omsIDs: [
            '203294119',
            '203781217',
            '203075731',
            '203310023',
            '203310025'
          ]
        }
      ]
    },
    {
      imageUrl: 'https://images.thdstatic.com/productImages/2734026a-c37a-4857-a16e-c0baa3478034/svn/xramfy-wall-mirrors-brtrc2436-black-44_1000.jpg',
      hotspots: [
        {
          coordinate: {
              xCoordinate: '0.49929415893554685',
              yCoordinate: '0.8034664306640625'
          },
          omsIDs: [
              '206520599',
              '332741902',
              '332742058',
              '313633327',
              '332741900'
          ]
        },
        {
            coordinate: {
                xCoordinate: '0.700458984375',
                yCoordinate: '0.6053634033203125'
            },
            omsIDs: [
                '314697059',
                '327648236',
                '327377199',
                '329422850',
                '332494254'
            ]
        },
        {
            coordinate: {
                xCoordinate: '0.28620913696289063',
                yCoordinate: '0.6001455078125'
            },
            omsIDs: [
                '100480499',
                '314697059',
                '202369649',
                '327648236',
                '332494254'
            ]
        }
      ]
    }],
    shopByRoom: [{
      url: '/collection/bathroom/casual_haven/id-40600',
      metadata: {
        name: 'Casual Haven',
        style: [
          'Classic',
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/23d9f8d4-ef86-4225-81d8-046144c7d84921.jpeg'
      }
    },
    {
      url: '/collection/bathroom/cool_classic/id-40418',
      metadata: {
        name: 'Cool Classic',
        style: [
          'Classic',
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/2a873581-d30b-47f1-8574-4f10f0f2d4631.jpeg'
      }
    },{
      url: '/collection/bathroom/enivo_components_suite/id-39580',
      metadata: {
          name: 'Enivo Components Suite',
          style: [
              'Modern'
          ],
          room: [
              'Bathroom'
          ],
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/f2fdf982-4cde-432f-9dbd-2fdb2bc287424.jpeg'
      }
    }]
  },
  {
    collectionId: 'Family-304307888',
    anchorId: '202523283',
    kitchenAnchorId: '202524953',
    shopInspiration: [{
      imageUrl: 'https://images.thdstatic.com/productImages/c084256a-0b41-4986-99af-569f23fc65aa/svn/chrome-delta-towel-bars-fnd18-pc-66_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.593691162109375',
            yCoordinate: '0.13503555297851563'
          },
          omsIDs: [
            '330290623',
            '330290875',
            '300111784',
            '324757087',
            '303019433'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.24051181030273439',
            yCoordinate: '0.12281819152832031'
          },
          omsIDs: [
            '330290623',
            '330290875',
            '300111784',
            '324757087',
            '326507315'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.829665771484375',
            yCoordinate: '0.73635498046875'
          },
          omsIDs: [
            '203309217',
            '322473338',
            '320028528',
            '316927558',
            '313542160'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.680776611328125',
            yCoordinate: '0.666048583984375'
          },
          omsIDs: [
            '204285818',
            '314278871',
            '330347394',
            '302349469',
            '207172522'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.130025146484375',
            yCoordinate: '0.1704306640625'
          },
          omsIDs: [
            '204285736',
            '302349079',
            '318267814',
            '204322467',
            '326718104'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.6012479248046875',
            yCoordinate: '0.31064788818359373'
          },
          omsIDs: [
            '205149041',
            '204337232',
            '315289822',
            '322302859',
            '322405565'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.462399658203125',
            yCoordinate: '0.727593505859375'
          },
          omsIDs: [
            '305168581',
            '327585720',
            '327585664',
            '304968542',
            '305168591'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.41961431884765626',
            yCoordinate: '0.25719482421875'
          },
          omsIDs: [
            '331621665',
            '331621666',
            '303576480',
            '303575911',
            '323068649'
          ]
        }
      ]
    },
    {
      imageUrl: 'https://images.thdstatic.com/productImages/a34019ee-d58f-4ab6-a4d7-f4e3fc040b2a/svn/chrome-delta-bathtub-shower-faucet-combos-b114900c-1d_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.6077538452148438',
            yCoordinate: '0.6064918212890625'
          },
          omsIDs: [
            '204342305',
            '100094383',
            '202547794',
            '302568741',
            '312281764'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.8076881103515625',
            yCoordinate: '0.6219969482421875'
          },
          omsIDs: [
            '314293510',
            '207050606',
            '302963014',
            '205840982',
            '204626967'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.4137389526367187',
            yCoordinate: '0.4702956848144531'
          },
          omsIDs: [
            '326882340',
            '320176788',
            '321066569',
            '326882344',
            '207095354'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.13948200988769532',
            yCoordinate: '0.49890603637695313'
          },
          omsIDs: [
            '315276784',
            '327656283',
            '302852760',
            '315276786',
            '315289646'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.26319964599609375',
            yCoordinate: '0.6511670532226562'
          },
          omsIDs: [
            '206600631',
            '204681799',
            '301340878',
            '307652675',
            '207003239'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.23025363159179688',
            yCoordinate: '0.4331249389648438'
          },
          omsIDs: [
            '325052665',
            '100508078',
            '325052477',
            '321303442',
            '302855772'
          ]
        }
      ]
    }
    ],
    shopByRoom: [{
      url: '/collection/bathroom/timeless_retreat/id-39505',
      metadata: {
        name: 'Timeless Retreat',
        style: [
          'Classic',
          'Vintage'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/398bfd08-136a-42cb-bf97-2761904821e15.jpeg'
      }
    },
    {
      url: '/collection/bathroom/classic_haven_bathroom/id-37989',
      metadata: {
        name: 'Classic Haven Bathroom',
        style: [
          'Classic',
          'Vintage'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/2c0097a2-fdd8-4f71-aa73-47f2e41f0d9092.jpeg'
      }
    },
    {
      url: '/collection/bathroom/southerk_suite/id-39586',
      metadata: {
          name: 'Southerk Suite',
          style: [
              'Coastal',
              'Modern'
          ],
          room: [
              'Bathroom'
          ],
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/26b80c3f-62dd-4d30-8551-1da5c3e7c3c28.jpeg'
      }
    }]
  },
  {
    collectionId: 'Family-313679804',
    anchorId: '305094960',
    kitchenAnchorId: '',
    shopInspiration: [{
      imageUrl: 'https://images.thdstatic.com/productImages/cda0d8b7-1c8e-452c-8feb-6610d8d9e8b8/svn/polished-chrome-pfister-single-hole-bathroom-faucets-lg42-dapc-76_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.14475070190429687',
            yCoordinate: '0.707047607421875'
          },
          omsIDs: [
            '313826620',
            '322034381',
            '307952434',
            '307953208',
            '307952433'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.4991802368164063',
            yCoordinate: '0.7618272094726563'
          },
          omsIDs: [
            '205925382',
            '326631712',
            '308156782',
            '315195220',
            '320219826'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.21955453491210938',
            yCoordinate: '0.42726348876953124'
          },
          omsIDs: [
            '302118886',
            '302118885',
            '326480296',
            '326480301',
            '303009611'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.56336572265625',
            yCoordinate: '0.42971444702148437'
          },
          omsIDs: [
            '313584326',
            '313584319',
            '307310949',
            '313584353',
            '313584330'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.4127333068847656',
            yCoordinate: '0.42887554931640626'
          },
          omsIDs: [
            '313584326',
            '313584319',
            '323814160',
            '313584353',
            '313584330'
          ]
        }
      ]
    },
    {
      imageUrl: 'https://images.thdstatic.com/productImages/79152158-d95a-4c27-8b3a-8f76870f2114/svn/brushed-nickel-towel-bars-ec-tb-225-g-31_1000.jpg',
      hotspots: [
        {
          coordinate: {
            xCoordinate: '0.28653564453125',
            yCoordinate: '0.8252054443359375'
          },
          omsIDs: [
            '204633520',
            '328014925',
            '324635113',
            '324635116',
            '329256362'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.13875230407714845',
            yCoordinate: '0.76105224609375'
          },
          omsIDs: [
            '316166572',
            '306194568',
            '316783395',
            '314108165',
            '207095356'
          ]
        },
        {
          coordinate: {
            xCoordinate: '0.49368853759765624',
            yCoordinate: '0.5378826904296875'
          },
          omsIDs: [
            '330217889',
            '100067250',
            '313429496',
            '316166199',
            '300288260'
          ]
        }
      ]
    }

    ],
    shopByRoom: [{
      url: '/collection/bathroom/tranquil_opulence/id-39517',
      metadata: {
        name: 'Tranquil Opulence',
        style: [
          'Glam',
          'Modern'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/d826fcc1-4b8f-4370-84d8-bfa8c476b85516.jpeg'
      }
    },
    {
      url: '/collection/bathroom/luxe_coastal_bathroom/id-39422',
      metadata: {
        name: 'Luxe Coastal Bathroom',
        style: [
          'Coastal',
          'Glam'
        ],
        room: [
          'Bathroom'
        ],
        imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/f0f4486f-b5dd-444f-8b78-fbbde26b582d7.jpeg'
      }
    },
    {
      url: '/collection/bathroom/cordana_collection/id-37212',
      metadata: {
          name: 'Cordana Collection',
          style: [
              'Classic'
          ],
          room: [
              'Bathroom'
          ],
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/640x426/4b009811-bd59-42e8-9653-0d8900089f2331.jpeg'
      }
    }]
  }
];

export const requestKey = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';
export const schemaName = 'pipcollection';

